/* eslint-disable import/prefer-default-export */
export { default as CustomerStoryTile } from './CustomerStoryTile';
export { customerStoryTileAdapter } from './adapters';
